<template>
  <BProgress v-if="value !== null"
             class="my-2 position-relative">
    <BProgressBar :value="value">
      <span class="justify-content-center d-flex position-absolute w-100">{{ value }} %</span>
    </BProgressBar>
  </BProgress>
</template>

<script>
  import {
    BProgress, BProgressBar,
  } from 'bootstrap-vue';

  export default {
    name: 'PercentageBar',
    compatConfig: {
      MODE: 3,
    },
    components: {
      BProgress,
      BProgressBar,
    },
    data() {
      return {
        value: null,
      };
    },
    beforeMount() {
      this.value = this.params.value ?? null;
    },
  };
</script>
